<style lang="scss" scoped>
::v-deep .success-message {
    @apply text-white;
}
</style>

<template>
    <div class="w-full" ref="form">
        <ValidationObserver ref="observer" tag="form" class="flex flex-col md:flex-row w-full md:items-center" @submit.prevent="submit('/api/subscribe')">
            <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="bundledTranslations.email" :slim="true">
                <div class="w-full sm:translate-y-[8px]" :class="props.classes">
                    <input v-model="formData.email" class="form__input form__input--underline" type="email" name="email" :placeholder="bundledTranslations.email_placeholder" />
                </div>
            </ValidationProvider>

            <button type="submit" class="mt-sm justify-center md:mt-0 md:ml-sm flex-shrink-0 btn btn--outline btn--primary">
                Inschrijven
                <i class="fa-light fa-arrow-right"></i>
            </button>
            <span v-if="compiledErrors && compiledErrors.length" class="error text-red text-xs leading-none inline-block mb-5">{{ compiledErrors[0] }}</span>
        </ValidationObserver>
        <span v-if="emailErrors && emailErrors.length" class="text-red text-xs leading-none inline-block">{{ emailErrors[0] }}</span>
    </div>
</template>

<script>
import formBaseRecaptcha from '@/mixins/formBaseRecaptcha';

export default {
    name: 'newsletter-subscribe',

    mixins: [formBaseRecaptcha],

    props: {
        translations: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            formData: {
                first_name: null,
                last_name: null,
                email: '',
                language: document.documentElement.lang,
            },
            isMounted: false,
            recaptchaAction: 'newsletterform',
            defaultTranslations: {
                email: 'E-mailadres',
                email_placeholder: 'Vul hier je e-mailadres in',
                success_message: 'Bedankt om je in te schrijven op de nieuwsbrief',
            },
        };
    },

    computed: {
        emailErrors() {
            if (!this.isMounted) {
                return [];
            }
            return this.$refs.email.errors;
        },
        bundledTranslations() {
            return Object.assign(this.defaultTranslations, this.translations);
        },
    },

    mounted() {
        this.isMounted = true;
    },
};
</script>
